








import Vue from 'vue';

export default Vue.extend({
  props: {
    outline: {
      type: Boolean,
      default: false,
    },
    enableHover: {
      type: Boolean,
      default: false,
    },
  },
});
